import React, { useEffect, useState } from "react";

export type BioMetricResult = {
  result?: boolean;
  isLoading: boolean;
};

export default function useBioMetrics(): [BioMetricResult, () => void, string] {
  const [result, setResult] = React.useState<BioMetricResult>({
    isLoading: false,
  });
  const [log, setLog] = useState("");

  const bioCall = function () {
    setResult((prev) => ({ isLoading: true }));
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.bioCall) {
        setLog("android available");
        window.SANDI.bioCall();
      } else {
        setLog("android not available");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setLog("ios called" + JSON.stringify(window.webkit));
      window.webkit?.messageHandlers.biometrics.postMessage("bioCall");
    } else {
      //아이폰, 안드로이드 외
      return "other";
    }
  };

  const handleBiometrics = function (isSuccess: any) {
    setLog("handleBiometrics called" + isSuccess.toString() + typeof isSuccess);
    setResult({
      result: isSuccess.toString() === "true" ? true : false,
      isLoading: false,
    });
  };

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (result.isLoading === true) {
      timeoutId = setTimeout(() => {
        setLog("result.isLoading");
        setResult((prev) => ({ isLoading: false, result: false }));
      }, 3000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [result.isLoading]);

  useEffect(() => {
    window.handleBiometrics = handleBiometrics;
  }, []);

  return [result, bioCall, log];
}
